/* Allorn — About page journey: swap the pinned picture as each narrator's step scrolls by,
   and flip before → after halfway through a step. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initJourney = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const steps = [...root.querySelectorAll('[data-step]')];
    const medias = [...root.querySelectorAll('[data-step-media]')];
    const dots = [...root.querySelectorAll('[data-step-dot]')];
    let active = -1;

    const loadPlay = (el) => {
      el.querySelectorAll('video').forEach((v) => {
        if (!v.src && v.dataset.src) v.src = v.dataset.src;
        if (!reduce) v.play().catch(() => {});
      });
    };
    const pauseAll = (el) => el.querySelectorAll('video').forEach((v) => v.pause());

    const setActive = (i) => {
      if (i === active) return;
      active = i;
      steps.forEach((s, k) => s.classList.toggle('is-active', k === i));
      medias.forEach((m, k) => {
        m.classList.toggle('is-active', k === i);
        if (k === i) loadPlay(m);
        else pauseAll(m);
      });
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    };

    let frame = 0;
    const update = () => {
      frame = 0;
      const mid = window.innerHeight * 0.5;
      let best = 0;
      let bestDist = Infinity;
      steps.forEach((s, k) => {
        const r = s.getBoundingClientRect();
        const d = Math.abs((r.top + r.bottom) / 2 - mid);
        if (d < bestDist) { bestDist = d; best = k; }
      });
      setActive(best);
      // Before → after once the step has scrolled a little past the middle.
      const r = steps[best].getBoundingClientRect();
      const progress = (mid - r.top) / Math.max(r.height, 1);
      const m = medias[best];
      if (m) m.classList.toggle('is-after', progress > 0.55);
      // Mobile: play inline videos only while they're on screen.
      steps.forEach((s) => {
        const inl = s.querySelector('.al-journey__inline');
        if (!inl || getComputedStyle(inl).display === 'none') return;
        const rr = inl.getBoundingClientRect();
        if (rr.bottom > 0 && rr.top < window.innerHeight) loadPlay(inl);
        else pauseAll(inl);
      });
    };
    const queue = () => { if (!frame) frame = requestAnimationFrame(update); };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    update();
  };

  const init = (r = document) => r.querySelectorAll('[data-al-journey]').forEach(initJourney);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
